import { Real } from "@siteimprove/alfa-math";
/**
 * @public
 */
export class Numeric {
    /**
     * The number of decimals stored for every numeric value.
     */
    static Decimals = 7;
    _value;
    _type;
    constructor(value, type) {
        this._type = type;
        this._value = Real.round(value, Numeric.Decimals);
    }
    get type() {
        return this._type;
    }
    get value() {
        return this._value;
    }
    equals(value) {
        return value instanceof Numeric && value._value === this._value;
    }
    hash(hash) {
        hash.writeFloat64(this._value);
    }
    toJSON() {
        return {
            type: this._type,
            value: this._value,
        };
    }
    toString() {
        return `${this._value}`;
    }
}
/**
 * @public
 */
(function (Numeric) {
    function isNumeric(value) {
        return value instanceof Numeric;
    }
    Numeric.isNumeric = isNumeric;
})(Numeric || (Numeric = {}));
//# sourceMappingURL=numeric.js.map